import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { RestCallerService } from '../common/services/rest-caller.service';

declare var jquery: any;
declare var $: any;
declare var swal: any;
declare var alasql: any;

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.css']
})

export class UserManagementComponent implements OnInit, OnDestroy {

  addInternalUserForm: FormGroup;
  addExternalUserForm: FormGroup;
  updateInternalUserForm: FormGroup;
  updateExternalUserForm: FormGroup;
  updateAssociatedClientsForm: FormGroup;
  deactivateUserForm: FormGroup;
  reactivateUserForm: FormGroup;

  showLoader: boolean = false;
  showUserList: boolean = false;
  showClientLists: boolean = false;
  haveUserList: boolean = false;
  alertMessage: string;
  showErrorMessage: boolean;
  errorClass: string;

  userList: Object[] = [];
  filteredUserList: object[] = [];
  clientList: Object[] = [];
  associatedClientIdList: any = [];
  associatedClientList: any = [];

  selectedNewClient: Object;
  selectedCurrentClients: Object[];

  public queryClientList = '';
  public filteredClientList = [];

  userTableFilterValue: string;

  constructor(private restCallingService: RestCallerService) {

  }

  ngOnDestroy() {
    $('.nav>li.active').removeClass("active");
  }

  ngOnInit() {
    this.addInternalUserForm = new FormGroup({
      'username': new FormControl(),
    });
    this.addExternalUserForm = new FormGroup({
      'username': new FormControl(),
      'firstName': new FormControl(),
      'lastName': new FormControl(),
    });
    this.updateInternalUserForm = new FormGroup({
      'username': new FormControl(),
    });
    this.updateExternalUserForm = new FormGroup({
      'username': new FormControl(),
      'firstName': new FormControl(),
      'lastName': new FormControl(),
    });
    this.updateAssociatedClientsForm = new FormGroup({
      'username': new FormControl(),
    });
    this.deactivateUserForm = new FormGroup({
      'username': new FormControl(),
    });
    this.reactivateUserForm = new FormGroup({
      'username': new FormControl(),
    });

    $('#user-mgmt').addClass('active');

  }

  addInternalUser() {
    let s: string = this.addInternalUserForm.value["username"];
    this.addInternalUserForm.patchValue({username: s.trim()});
    let userName: string = this.addInternalUserForm.value["username"];
    this.showLoader = true;
    this.restCallingService.addInternalUser(userName).subscribe(
      data => {
        this.showLoader = false;
        console.log(data);
        swal("Success!", "Internal User Added Successfully!", "success");
      },
      err => {
        this.showLoader = false;
        console.log(err.json());
        swal("Failure", err.json().message, 'error');
      });
  }

  addExternalUser() {
    let s: string = this.addExternalUserForm.value["username"];
    this.addExternalUserForm.patchValue({username: s.trim().toLowerCase()});
    // original regex ^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$
    var emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
    let extPattern = new RegExp(emailRegex);
    if (extPattern.test(this.addExternalUserForm.value["username"]) === false)
      swal("Invalid Email", "Please enter a valid email address." , "warning");
    else if (!this.addExternalUserForm.value["username"] || !this.addExternalUserForm.value["firstName"] || !this.addExternalUserForm.value["lastName"])
      swal("Invalid User", "Please complete all fields." , "warning");
    else {
      let formObject: any = {};
      formObject.username = this.addExternalUserForm.value["username"];
      formObject.firstName = this.addExternalUserForm.value["firstName"];
      formObject.lastName = this.addExternalUserForm.value["lastName"];
      this.showLoader = true;
      this.restCallingService.addExternalUser(formObject).subscribe(
        data => {
          this.showLoader = false;
          console.log(data);
          swal("Success!", "External User Added Successfully!", "success");
        },
        err => {
          this.showLoader = false;
          console.log(err.json());
          swal("Failure", err.json().message, 'error');
        });
    }
  }

  updateInternalUser() {
    let userName: string = this.updateInternalUserForm.value["username"];
    this.showLoader = true;
    this.restCallingService.updateInternalUser(userName).subscribe(
      data => {
        this.showLoader = false;
        console.log(data);
        swal("Success!", "Internal User Updated Successfully!", "success");
      },
      err => {
        this.showLoader = false;
        console.log(err.json());
        swal("Failure",err.json().message, 'error');
      });
  }

  updateExternalUser() {
    let formObject: any = {};
    formObject.username = this.updateExternalUserForm.value["username"];
    formObject.firstName = this.updateExternalUserForm.value["firstName"];
    formObject.lastName = this.updateExternalUserForm.value["lastName"];
    this.showLoader = true;
    this.restCallingService.updateExternalUser(formObject).subscribe(
      data => {
        this.showLoader = false;
        console.log(data);
        swal("Success!", "External User Updated Successfully!", "success");
      },
      err => {
        this.showLoader = false;
        console.log(err.json());
        swal("Failure",err.json().message, 'error');
      });
  }

  fetchAssociatedClients() {
    this.refreshClientLists();
    let formObject: any = {};
    formObject.username = this.updateAssociatedClientsForm.value["username"];
    if (!formObject.username) {
      swal('No User Provided', 'Please provide a valid username or email.', 'warning');
      return;
    }
    this.showLoader = true;
    this.restCallingService.getAssociatedClientsForExternalUser(formObject).subscribe(
      data => {
        this.showLoader = false;
        this.showClientLists = true;
        let obj: any = data.json();
        this.associatedClientIdList = obj["clientIdList"];
        for (var id in this.associatedClientIdList) {
          let id_num = Number(this.associatedClientIdList[id]);
          this.restCallingService.getClientById(id_num).subscribe(
            data => {
              this.showLoader = false;
              let response: any = data.json();
              this.associatedClientList.push(response);
            },
            err => {
              this.showLoader = false;
              console.log(err.json());
              // swal("Failure",err.json().message, 'error');
            });
        }
        console.log(data);
        console.log(this.associatedClientList);
      },
      err => {
        this.showLoader = false;
        console.log(err.json());
        swal("Failure",err.json().message, 'error');
      });
    this.getAllClients();
  }

  getAllClients() {
    let formObject: any = {};
    this.showLoader = true;
    this.restCallingService.getListofClientForInternalUser(formObject).subscribe(
      data => {
        this.showLoader = false;
        this.clientList = data.json().filter(function(a) { return a.name !== null; } ).sort(function (a, b) {
          if (a.name.toUpperCase() < b.name.toUpperCase()) { return -1; }
          if (a.name.toUpperCase() > b.name.toUpperCase()) { return 1; }
          return 0;
        });
        console.log(data);
      },
      err => {
        this.showLoader = false;
        console.log(err.json());
        swal("Failure",err.json().message, 'error');
      });
  }

  refreshClientLists() {
    this.associatedClientIdList = [];
    this.associatedClientList = [];
    this.clientList = [];
    this.selectedCurrentClients = [];
    this.selectedNewClient = null;
  }

  associateNewClient() {
    if (this.selectedNewClient) {
      if (!this.associatedClientList.find(client => client.id == this.selectedNewClient["id"]))
        this.associatedClientIdList.push(this.selectedNewClient["id"]);
      else {
        this.showLoader = false;
        this.queryClientList = '';
        swal("Error", "Selected client is already associated with this user", "error");
        return;
      }
    }
    else {
      this.showLoader = false;
      this.queryClientList = '';
      swal("Error", "Must select a new client to associate", "error");
      return;
    }
    let formObject: any = {};
    formObject["clientIdList"] = this.associatedClientIdList;
    formObject["username"] = this.updateAssociatedClientsForm.value["username"];
    this.showLoader = true;
    this.restCallingService.setAssociatedClientsForExternalUser(formObject).subscribe(
      data => {
        this.showLoader = false;
        this.queryClientList = '';
        console.log(data);
        swal("Success!", "Client Associated Successfully!", "success").then(()=>{
          this.fetchAssociatedClients(); //refresh lists 
        });
      },
      err => {
        this.showLoader = false;
        console.log(err.json());
        swal("Failure", err.json().message, 'error');
      });
  }

  disassociateClient() {
    if (this.selectedCurrentClients && this.selectedCurrentClients.length > 0) {
      for (let cl of this.selectedCurrentClients) {
        this.associatedClientIdList = this.associatedClientIdList.filter(id => id != cl["id"]);
      }
    }
    else {
      swal("Error", "Must select at least one client to disassociate", "error");
      return;
    }
    let formObject: any = {};
    formObject["clientIdList"] = this.associatedClientIdList;
    formObject["username"] = this.updateAssociatedClientsForm.value["username"];
    this.showLoader = true;
    this.restCallingService.setAssociatedClientsForExternalUser(formObject).subscribe(
      data => {
        this.showLoader = false;
        console.log(data);
        swal("Success!", "Client(s) Disassociated Successfully!", "success").then(()=>{
          this.fetchAssociatedClients(); //refresh lists
        });
      },
      err => {
        this.showLoader = false;
        console.log(err.json());
        swal("Failure", err.json().message, 'error');
      });
  }

  deactivateUser() {
    let formObject: any = {};
    let userName: string = this.deactivateUserForm.value["username"];
    this.showLoader = true;
    this.restCallingService.deactivateUser(userName).subscribe(
      data => {
        this.showLoader = false;
        console.log(data);
        swal("Success!", "User Deactivated Successfully!", "success");
      },
      err => {
        this.showLoader = false;
        console.log(err.json());
        swal("Failure", err.json().message, 'error');
      });
  }

  reactivateUser() {
    let formObject: any = {};
    let userName: string = this.reactivateUserForm.value["username"];
    this.showLoader = true;
    this.restCallingService.reactivateUser(userName).subscribe(
      data => {
        this.showLoader = false;
        console.log(data);
        swal("Success!", "User Reactivated Successfully!", "success");
      },
      err => {
        this.showLoader = false;
        console.log(err.json());
        swal("Failure", err.json().message, 'error');
      });
  }

  deleteUser(user) {
    swal({ title: 'Are you sure?', text: 'Are you sure you want to delete User?', icon: 'warning', buttons: true }).then(
      (isConfirmed) => {
        if (isConfirmed) {
          this.showLoader = true;
          this.restCallingService.deactivateUser(user.username).subscribe(
            data => {
              this.showLoader = false;
              this.haveUserList = false;
              this.getUserList();
              swal('Success!', 'User Deleted Successfully!', 'success');
            },
            err => {
              this.showLoader = false;
              console.log(err.json());
              swal('Failure!',err.json().message,'error');
            });
        };
      }
    );
  }

  getUserList() {
    if (this.haveUserList == false) {
      this.showLoader = true;
      this.restCallingService.getUserList().subscribe(
        data => {
          this.showLoader = false;
          this.haveUserList = true;
          this.userList = data.json();
          this.filteredUserList = data.json();
        },
        err => {
          this.showLoader = false;
          console.log(err.json());
          swal("Failure", err.json().message, 'error');
        });
    }
  }

  toggleAddUserSection() {
    if ($('.add-user-icon').hasClass('fa-plus-circle')) {
      $("#userManagementAddUserSection").slideDown();
      $('.add-user-icon').toggleClass('fa-plus-circle fa-minus-circle');
    }
    else {
      $("#userManagementAddUserSection").slideUp();
      $('.add-user-icon').toggleClass('fa-plus-circle fa-minus-circle');
    }
  }

  toggleUpdateUserSection() {
    if ($('.update-user-icon').hasClass('fa-plus-circle')) {
      $("#userManagementUpdateUserSection").slideDown();
      $('.update-user-icon').toggleClass('fa-plus-circle fa-minus-circle');
    }
    else {
      $("#userManagementUpdateUserSection").slideUp();
      $('.update-user-icon').toggleClass('fa-plus-circle fa-minus-circle');
    }
  }

  toggleActivateUserSection() {
    if ($('.activate-user-icon').hasClass('fa-plus-circle')) {
      $("#userManagementActivateUserSection").slideDown();
      $('.activate-user-icon').toggleClass('fa-plus-circle fa-minus-circle');
    }
    else {
      $("#userManagementActivateUserSection").slideUp();
      $('.activate-user-icon').toggleClass('fa-plus-circle fa-minus-circle');
    }
  }

  toggleUserListSection() {
    if ($('.user-list-icon').hasClass('fa-plus-circle')) {
      $("#userManagementUserListSection").slideDown();
      $('.user-list-icon').toggleClass('fa-plus-circle fa-minus-circle');
      this.getUserList();
    }
    else {
      $("#userManagementUserListSection").slideUp();
      $('.user-list-icon').toggleClass('fa-plus-circle fa-minus-circle');
    }
  }


  filterClientList() {
    if (this.queryClientList !== '' && this.clientList !== undefined) {
      this.filteredClientList = this.clientList.filter(function (el) {
        return el.name.toLowerCase().indexOf(this.queryClientList.toLowerCase()) >= 0;
      }.bind(this));
    } else {
      this.filteredClientList = this.clientList.slice(0, 9);
    }
    this.filteredClientList = this.filteredClientList.slice(0, 9);
  }

  filterUserList() {
    if (this.userTableFilterValue === undefined) {
      return false;
    }
    if (this.userTableFilterValue !== '' && this.userList !== undefined) {
      this.filteredUserList = this.userList.filter(function (el) {
        return el.firstName.toLowerCase().indexOf(this.userTableFilterValue.toLowerCase()) >= 0 ||
          el.lastName.toLowerCase().indexOf(this.userTableFilterValue.toLowerCase()) >= 0 ||
          el.username.toLowerCase().indexOf(this.userTableFilterValue.toLowerCase()) >= 0;
      }.bind(this));
    } else {
      this.filteredUserList = this.userList;
    }
  }

  clientFocus() {
    this.filteredClientList = this.clientList.slice(0, 9);
  }

  onClientSelection(selectedItem) {
    this.selectedNewClient = selectedItem;
    this.queryClientList = selectedItem.name;
    this.filteredClientList = [];
  }

  exportCSV() {
    if (!this.userList)
      return;
    if (this.userList.length == 0) {
      swal('Error:', 'Table must contain at least one record to export.', 'warning');
      return;
    }
    let data: any = [];
    let columnMap : Map<string,string> = new Map<string, string>();
    columnMap.set('username', 'Username');
    columnMap.set('firstName', 'First Name');
    columnMap.set('lastName', 'Last Name');
    columnMap.set('externalUser', 'External?') ;
    columnMap.set('admin', 'Admin?');
    let columns: any = [];
    for (let colName of Array.from(columnMap.values())) {
      columns.push(colName);
    }
    data.push(columns);
    for(let row of this.userList) {
      let record: any = [];
      for (let col of Array.from(columnMap.keys())) {
        record.push(row[col] || '');
      }
      data.push(record);
    }
    alasql.promise('SELECT * INTO CSV("USER_LIST_EXPORT.CSV", {headers:false, separator:","\}) FROM ?', [data])
      .then(function () {
        console.log('Data saved');
      }).catch(function (err) {
        console.log('Error:', err);
      });
  }

}





// WEBPACK FOOTER //
// ./src/app/user-management/user-management.component.ts